import { Controller } from "@hotwired/stimulus";
import { handleHttpResponse, postAjaxRequest } from "../../utils/http_utils";
import { fetchStream } from "../../utils/turbo_utils";
import { closeModal, appendUrlSearchParams } from "../../utils/misc";

export default class extends Controller {
  static targets = ["submitBtn", "loader", "newSocialFormInput"];
  static values = {
    socialFormUpdateUrl: String,
    socialFormUpdateRequirementsUrl: String,
  };

  toggleLoader() {
    this.submitBtnTarget.classList.toggle("hidden");
    this.loaderTarget.classList.toggle("hidden");
  }

  afterVerification(e) {
    handleHttpResponse({
      payload: e.detail[0],
      onSuccess: (response) => {
        const data = JSON.parse(response);
        const newSocialForm = this.newSocialFormInputTarget.value;

        if (data.requires_confirmation) {
          this._askUserToConfirmSocialFormUpdate(newSocialForm);
        } else {
          this._updateSocialForm(newSocialForm);
        }
      },
    });
  }

  _askUserToConfirmSocialFormUpdate(newSocialForm) {
    const url = appendUrlSearchParams(this.socialFormUpdateRequirementsUrlValue, { social_form: newSocialForm });
    fetchStream(url);
  }

  _updateSocialForm(newSocialForm) {
    postAjaxRequest(this.socialFormUpdateUrlValue, { social_form: newSocialForm })
      .then((response) => response.text())
      .then((js) => eval(js))
      .finally(() => closeModal("edit-company-creation-social-form"));
  }
}
